import { createAuthClient } from 'better-auth/react';
import {
  lastLoginMethodClient,
  customSessionClient,
  genericOAuthClient,
  anonymousClient,
  emailOTPClient,
} from 'better-auth/client/plugins';
import type { auth } from '@/lib/auth';

export const authClient = createAuthClient({
  // baseURL must NOT include a path — better-auth appends basePath separately.
  baseURL: process.env.NODE_ENV === 'production'
    ? 'https://evaii.ru'
    : 'http://localhost:3000',
  basePath: '/api/auth',
  plugins: [
    lastLoginMethodClient(),
    customSessionClient<typeof auth>(),
    genericOAuthClient(),
    // Guest-mode: exposes authClient.signIn.anonymous() + session.user.isAnonymous typing.
    // Server counterpart is conditional on GUEST_MODE_ENABLED; when flag is off the
    // endpoint returns 404 (client-side types are harmless).
    anonymousClient(),
    // Email-OTP: дает authClient.emailOtp.sendVerificationOtp + authClient.signIn.emailOtp.
    emailOTPClient(),
  ],
});

export const { signIn, signOut, signUp, useSession } = authClient;
